import axios from 'axios';
import environment from '../../../environment';

const encryptCache = new Map();
const decryptCache = new Map();

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

export async function encryptId(id) {
    if (!id) return "";
    const key = String(id);
    if (encryptCache.has(key)) return encryptCache.get(key);

    try {
        const res = await axios.post(`${environment.api}api/crypto/encrypt`,
            { ids: [key] },
            { headers: { 'Content-Type': 'application/json', ...getAuthHeaders() } }
        );
        if (res.data?.success && res.data?.data?.[key]) {
            const encrypted = res.data.data[key];
            encryptCache.set(key, encrypted);
            return encrypted;
        }
    } catch (err) {
        console.error('encryptId failed:', err);
    }
    return key;
}

export async function decryptId(maybeEncryptedId) {
    if (!maybeEncryptedId) return null;
    if (/^[0-9a-fA-F]{24}$/.test(maybeEncryptedId)) return maybeEncryptedId;

    const key = String(maybeEncryptedId);
    if (decryptCache.has(key)) return decryptCache.get(key);

    try {
        const res = await axios.post(`${environment.api}api/crypto/decrypt`,
            { ids: [key] },
            { headers: { 'Content-Type': 'application/json', ...getAuthHeaders() } }
        );
        if (res.data?.success && res.data?.data?.[key]) {
            const decrypted = res.data.data[key];
            decryptCache.set(key, decrypted);
            return decrypted;
        }
    } catch (err) {
        console.error('decryptId failed:', err);
    }
    if (/^[0-9a-fA-F]{24}$/.test(maybeEncryptedId)) return maybeEncryptedId;
    return null;
}
